import { isDefined } from '@takeshape/util';
import { apiCdnEndpoint, apiEndpoint } from '../config';
import { DEFAULT_BRANCH, SCRATCH_BRANCH } from './constants';

function makeApiUrl(apiPath: string, endpoint = apiEndpoint) {
  return [endpoint, apiPath].join('/');
}

export function getProjectEndpointPath(
  name: 'schema' | 'graphql',
  projectId: string,
  branch: string = DEFAULT_BRANCH,
  hash?: string
): string {
  const branchPathSegment = branch === DEFAULT_BRANCH || branch === SCRATCH_BRANCH ? [branch] : ['development', branch];
  return ['project', projectId, ...branchPathSegment, hash, name].filter(isDefined).map(encodeURIComponent).join('/');
}

export function getProjectEndpoint(projectId: string, branch: string, hash?: string): string {
  return makeApiUrl(getProjectEndpointPath('graphql', projectId, branch, hash));
}

export function getMcpEndpoint(projectId: string): string {
  return makeApiUrl(`project/${projectId}/mcp`);
}

export function getCdnEndpoint(projectId: string, branch: string): string {
  return makeApiUrl(getProjectEndpointPath('graphql', projectId, branch), apiCdnEndpoint);
}

export function getAdminEndpoint(projectId?: string) {
  return makeApiUrl(projectId ? ['project', projectId, 'admin-graphql'].join('/') : 'admin/graphql');
}

export function getSchemaEndpoint(projectId: string, branch?: string) {
  return makeApiUrl(getProjectEndpointPath('schema', projectId, branch));
}
